import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  payment = 'PricingDealsLp1001Payment',
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/deals-lp-1001/',
    component: () => import('@/modules/deals-lp-1001/layout/LayoutPage.vue'),
    children: [
      {
        path: 'payment/',
        name: MODULE_ROUTE.payment,
        component: () =>
          import('@/modules/deals-lp-1001/pages/payment/PagePayment.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
